enum FactoryInvoicingModel {
  PERIODICAL = "periodical",
  BY_SHIPMENTS_TO_HQ = "by shipments to the HQ",
}

export default FactoryInvoicingModel;
